module.exports = __webpack_public_path__ + "static/media/PRATIC - TRATAMENTO DE PISOS.0f05c7b3.pdf";